import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SpendingRequestCategory  {
    _originalTypeClassName = "zERP.BO.SpendingRequestCategory";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SpendingRequestCategory.translate = translateService;
}
this.SubCategories = [];
this.Id = null;
this.Name = null;
this.Description = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
SubCategories:any;
static setSubCategories = ($this, items) => {
                if (items == null) items = [];
                if ($this.SubCategories == null) $this.SubCategories = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SubCategories.length > 0) {
                    Domain.SpendingRequestCategory.removeSubCategories($this, $this.SubCategories[0]);
                }

                Domain.SpendingRequestCategory.addManySubCategories($this, copyItems);
            }
static addManySubCategories = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.SpendingRequestCategory.addSubCategories($this, items[i]);
                }
            }
static addSubCategories = ($this, item) => {
                if ($this.SubCategories == null) $this.SubCategories = [];
                if (item == null || $this.SubCategories.indexOf(item) > -1) return;
                $this.SubCategories.push(item);
if (item.SpendingRequestCategory != $this) {
Domain.SpendingRequestSubCategory.setSpendingRequestCategory(item, $this);
}
}
static addRangeSubCategories = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.SpendingRequestCategory.addSubCategories($this, item));
            }
static removeSubCategories = ($this, item) => {
                if ($this == null || $this.SubCategories == null || $this.SubCategories.indexOf(item) === -1) return;
                var _index = $this.SubCategories.indexOf(item);
                $this.SubCategories.splice(_index, 1);
item.SpendingRequestCategory = null;
}
static clearSubCategories = ($this) => { $this.SubCategories = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}